import React from 'react';

const boxInfo = props => (
    <div className="box-info"> 
        <h2 className={props.titleColor + " h5"}>{props.title}</h2>
        <p>{props.text}</p>
    </div>
);

export default boxInfo;